import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from 'assets/Logo';
import {
  Box,
  Flex,
  HStack,
  IconButton,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text as TextComponent,
  VStack,
} from '@chakra-ui/react';
import s from './Header.module.scss';
import { useMsal } from '@azure/msal-react';
import { userSelector } from 'api/slices/userSlice';
import { IconArrowDown, IconLogout, IconMenu } from 'components/Icons';
import LandsvirkjunLogoSmall from 'assets/landsvirkjun-logo-small.png';
import { useAppSelector } from 'store';
import { BackToLocation } from 'components/BackToLocation';

interface HeaderProps {
  onOpen: () => void;
}

export const Header = ({ onOpen }: HeaderProps): JSX.Element => {
  const { instance } = useMsal();
  const { user } = useAppSelector(userSelector);

  return (
    <header>
      <Flex
        px={5}
        alignItems="center"
        justifyContent="space-between"
        boxShadow="sm"
        className={s.header}
      >
        {/* Hamburger icon shown on mobile */}
        <IconButton
          display={{ base: 'flex', md: 'none' }}
          onClick={onOpen}
          variant="unstyled"
          aria-label="menu"
          icon={<IconMenu />}
        ></IconButton>
        <Box display={{ base: 'none', md: 'flex' }}>
          <Link to="/" className={s.header__logo}>
            <Logo />
          </Link>
          <BackToLocation />
        </Box>

        {/* Mobile logo */}
        <Box display={{ base: 'flex', md: 'none' }}>
          <Link to="/">
            <Image
              src={LandsvirkjunLogoSmall}
              alt="Landsvirkjun logo"
              className={s.header__mobilelogo_image}
            />
          </Link>
        </Box>

        {user && (
          <HStack spacing={{ base: '0', md: '6' }}>
            <Flex alignItems="center" display={{ base: 'none', md: 'flex' }}>
              <Menu>
                <MenuButton
                  _focus={{ boxShadow: 'none' }}
                  transition="all 0.2s"
                >
                  <HStack>
                    <VStack alignItems="flex-start" spacing="0.5">
                      <TextComponent>{user?.name}</TextComponent>
                    </VStack>
                    <Box>
                      <IconArrowDown />
                    </Box>
                  </HStack>
                </MenuButton>
                <MenuList
                  bg="white"
                  borderColor="border-light"
                  borderRadius={0}
                  zIndex={999}
                >
                  <MenuItem
                    onClick={(): Promise<void> => instance.logout()}
                    paddingTop={1}
                  >
                    <IconLogout style={{ marginRight: 5 }} /> Útskrá
                  </MenuItem>
                </MenuList>
              </Menu>
            </Flex>
          </HStack>
        )}
      </Flex>
    </header>
  );
};
